import { render, staticRenderFns } from "./OrgAppModules.vue?vue&type=template&id=27f7df09&scoped=true"
import script from "./OrgAppModules.vue?vue&type=script&lang=js"
export * from "./OrgAppModules.vue?vue&type=script&lang=js"
import style0 from "./OrgAppModules.vue?vue&type=style&index=0&id=27f7df09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f7df09",
  null
  
)

export default component.exports